module.exports = __webpack_public_path__ + "static/media/banner3.604e628a.jpg";